import { I18n } from '@calendly/i18n'

import { Spotlight } from 'components/core/spotlight'
import { MI_MEETINGS_TOUR } from 'features/meeting_intelligence/constants'
import { useURLParams } from 'features/meeting_intelligence/hooks'
import { handleDefaults } from 'features/meeting_intelligence/utils'
import { useTrack, useTrackOnce } from 'hooks/analytics_events/useTrack'

const STEP_THREE = {
  name: 'Tooltip Shown',
  properties: {
    tooltip_name: 'control_your_meetings',
    tooltip_flow: 'ai_notetaker_tour',
    tooltip_location: 'meetings_up_next',
  }
}

const STEP_THREE_CLICKED = {
  name: 'Tooltip Clicked',
  properties: {
    tooltip_name: 'control_your_meetings',
    tooltip_flow: 'ai_notetaker_tour',
    tooltip_location: 'meetings_up_next',
    action: 'tooltip_clicked'
  }
}

const STEP_THREE_DISMISSED = {
  name: 'Tooltip Clicked',
  properties: {
    tooltip_name: 'control_your_meetings',
    tooltip_flow: 'ai_notetaker_tour',
    tooltip_location: 'meetings_up_next',
    action: 'dismissed'
  }
}

export const StepThree = ({ isVisible = true }) => {
  const track = useTrack()
  const { findParam, removeParam } = useURLParams()
  const showTooltip = findParam(MI_MEETINGS_TOUR.STEP_THREE) && isVisible

  useTrackOnce(showTooltip, STEP_THREE)

  const handleContinue = (e) => {
    handleDefaults(e)
    track(STEP_THREE_CLICKED)
    removeParam(MI_MEETINGS_TOUR.STEP_THREE)
  }

  const handleDismiss = (e) => {
    handleDefaults(e)
    track(STEP_THREE_DISMISSED)
    removeParam(MI_MEETINGS_TOUR.STEP_THREE)
  }

  if (!showTooltip) return null

  return (
    <Spotlight
      headingText={I18n.t('publisher.meeting_intelligence.tour.step_three.title')}
      bodyText={I18n.t('publisher.meeting_intelligence.tour.step_three.body_text')}
      primaryButtonLabel={I18n.t('publisher.meeting_intelligence.tour.done')}
      footerText={I18n.t('publisher.meeting_intelligence.tour.step_three.progress')}
      onClickPrimary={handleContinue}
      placement="bottom"
      offset={10}
      onClose={handleDismiss}
      outsideClickDetectionEnabled={false}
    />
  )
}
